import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CommonService } from "src/@services/common.service";
import { EndPoints, RoleType } from "src/@shared/shared/enum";
import { PaymentsApiClient } from './api-clients';
import {
  ATTACHMENT_PREVIEW_PROVIDER,
  AttachmentPreviewPort,
} from './providers';
@Injectable({
  providedIn: "root",
})
export class CommonPagesService {
  userAccountsArray: any[] = [];
  userSitesArray: any[] = [];
  userSitesArrayCopy: any[] = [];
  paybevRoles: any[] = [];
  currentInvestorName: any = "";
  currentInvestorCompany: any = "";
  isInvestmentHisoryLoading: boolean = true;

  currentInvestorDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(
    private _cS: CommonService,
    private paymentsApiClient: PaymentsApiClient,
    @Inject(ATTACHMENT_PREVIEW_PROVIDER)
    private attachmentPreviewPort: AttachmentPreviewPort
  ) {}
  getRoles() {
    return this._cS.API_GET(
      EndPoints.GetRoles + `?roleType=${RoleType.Operator}`,
      false
    );
  }
  //create edit user
  createUser(userBody: any) {
    return this._cS.API_POST(EndPoints.AddUser, userBody);
  }
  EditUser(userBody: any) {
    return this._cS.API_POST(EndPoints.EditUser, userBody);
  }
  GetSite() {
    return this._cS.API_POST(EndPoints.GetSite, false);
  }
  UpdateProgramToStartingBalTransaction(reqBody: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.UpdateProgramToStartingBalTransaction,
      reqBody,
      false,
      {
        headers: hd,
      }
    );
  }
  GetStartingBalanceDetails(transactionsId: any) {
    return this._cS.API_GET(
      EndPoints.GetStartingBalanceDetails + `?TransactionsId=${transactionsId}`,
      false
    );
  }

  /*Programs*/
  addProgram(programBody: any) {
    return this._cS.API_POST(EndPoints.AddProgram, programBody);
  }
  updateProgram(programBody: any) {
    return this._cS.API_POST(EndPoints.UpdateProgram, programBody);
  }

  getProgramBySite() {
    return this._cS.API_GET(
      EndPoints.GetProgramBySite,
      false
    );
  }

  /*Vendors*/
  addVendor(vendorBody: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.AddNewVendor, vendorBody, false, {
      headers: hd,
    });
  }

  updatePaymentDetails(requestBody: any) {
    return this.paymentsApiClient.updatePayment(requestBody);
  }

  cancelPayment(cancelBody: any) {
    return this.paymentsApiClient.cancelPayment(cancelBody);
  }

  /*Investors*/
  addInvestor(investorBody: any) {
    return this._cS.API_POST(EndPoints.AddNewInvestor, investorBody);
  }
  getInvestorTerms(investorId: any) {
    return this._cS.API_GET(
      EndPoints.GetInvestorTerms + `?InvestorId=${investorId}`,
      false
    );
  }
  GetInvestmentDescription() {
    return this._cS.API_GET(EndPoints.GetInvestmentDescription, false);
  }

  /*Investment*/
  scheduleInvestment(investmentData: any) {
    return this._cS.API_POST(EndPoints.ScheduleInvestment, investmentData);
  }
  getInvestmentById(id: any) {
    return this._cS.API_GET(
      EndPoints.GetInvestmentById + `?InvestmentId=${id}`,
      false
    );
  }
  /* Single-document PDF, keyed by QuickBooks entity id. investmentType picks the QBO
     route - an estimate is not reachable on the invoice endpoint. */
  getInvoicePdf(qboInvoiceId: string, investmentType: number) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_GET(
      EndPoints.GetInvoicePdf + `/${qboInvoiceId}?investmentType=${investmentType}`,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }
  getSiteService(id: any) {
    return this._cS.API_GET(EndPoints.GetSiteService + `?siteId=${id}`, false);
  }
  updateInvestment(investmentData: any) {
    return this._cS.API_POST(EndPoints.UpdateInvestment, investmentData);
  }
  SaveInvestment(investmentData: any) {
    return this._cS.API_POST(EndPoints.SaveInvestment, investmentData);
  }
  updateInvestmentRequest(investmentData: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.EditInvestmentRequest,
      investmentData,
      false,
      {
        headers: hd,
      }
    );
  }
  cancelInvoice(cancelBody: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.CancelInvestment, cancelBody, false, {
      headers: hd,
    });
  }

  getInternalTransfer(internalTransferId: any) {
    return this._cS.API_GET(
      EndPoints.GetInternalTransfer + `?TransferId=${internalTransferId}`,
      false
    );
  }
  getExpense(expenseId: any) {
    return this._cS.API_GET(
      EndPoints.GetExpense + `?expenseID=${expenseId}`,
      false
    );
  }
  getRefund(refundsId: any) {
    return this._cS.API_GET(
      EndPoints.GetRefund + `?refundsId=${refundsId}`,
      false
    );
  }
  getCredit(creditId: any) {
    return this._cS.API_GET(
      EndPoints.GetCredit + `?CreditsId=${creditId}`,
      false
    );
  }
  getDeposit(depositId: any) {
    return this._cS.API_GET(
      EndPoints.GetDeposit + `?depositId=${depositId}`,
      false
    );
  }
  PreviewQBOAttachment(QBOAttachmentId: any) {
    return this.attachmentPreviewPort.previewQboAttachment(QBOAttachmentId);
  }
  updateInternalTransfer(internalTransferBody: any) {
    return this._cS.API_POST(
      EndPoints.UpdateInternalTransfer,
      internalTransferBody,
      false
    );
  }
  updateExpense(expenseBody: any) {
    return this._cS.API_POST(EndPoints.UpdateExpense, expenseBody, false);
  }
  updateCredit(creditBody: any) {
    return this._cS.API_POST(EndPoints.UpdateCredit, creditBody, false);
  }
  updateRefund(refundBody: any) {
    return this._cS.API_POST(EndPoints.UpdateRefund, refundBody, false);
  }
  updateDeposit(depositBody: any) {
    return this._cS.API_POST(EndPoints.UpdateDeposit, depositBody, false);
  }

  changePassword(requestBody: any) {
    return this._cS.API_POST(EndPoints.ChangePassword, requestBody, false);
  }

  //delete transaction
  deletePayment(paymentId: any) {
    return this._cS.API_DELETE(
      EndPoints.DeletePayment + `?paymentId=${paymentId}`
    );
  }
  deleteInvestment(formData: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.DeleteInvestment, formData, false, {
      headers: hd,
    });
  }
}
